import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { RoutePermissions } from '@nu-art/permissions-frontend/index';
import { EditableDBItemV3 } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_Action } from '@app/pathway-shared';
import { ModuleFE_Action, ModuleFE_OrderGroup } from '../../_entity.js';
import { ModuleFE_Resource, ModuleFE_Tag, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { ModuleFE_AdvisorSnippet, ModuleFE_AdvisorWizard } from '@app/advisor-content-frontend/_entity';
import { Renderer_SearchResult, SearchItemV3_With_ID } from '@app/styles';
import { EditorWrapper_Order } from './presenters/EditorWrapper_Order.js';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { Page_ActionManager } from './Page_ActionManager.js';
import { DBDef_OrderGroup } from '@app/pathway-shared';
import { Editor_OrderGroup } from '../Editor_OrderGroup/Editor_OrderGroup.js';
export const Route_ActionManager = {
    key: 'action-manager',
    path: 'action-manager',
    enabled: RoutePermissions(ModuleFE_Action.permissions.ui.Release),
    Component: Page_ActionManager,
    modulesToAwait: [ModuleFE_Action,
        ModuleFE_Resource,
        ModuleFE_Variable,
        ModuleFE_Tag,
        ModuleFE_Value,
        ModuleFE_AdvisorWizard,
        ModuleFE_AdvisorSnippet],
};
export const SearchableItem_Action = SearchItemV3_With_ID({
    module: ModuleFE_Action,
    type: DBDef_Action.dbKey,
    route: Route_ActionManager,
    entityName: ModuleFE_Action.dbDef.entityName,
    entityLabel: 'Action',
    groupId: ['Actions'],
    tags: [],
    mapper: (item) => [item.name],
    renderer: (item, selected, onClickCallback) => {
        const tags = ModuleFE_Tag.getTagsLabelByTagGroups(item?.tagGroups);
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: DBDef_Action.dbKey, itemLabel: item.name, entityLabel: item.type === 'order' ? 'Order' : 'Workflow', hierarchy: 'Actions', selected: selected, onClickCallback: onClickCallback, tags: tags });
    },
    resultRendererV2: ({ item }) => {
        return _jsx(EditorWrapper_Order, { editable: item });
    },
    resultRenderer: (itemId) => {
        return _jsx(_Fragment, {});
    }
});
export const SearchableItem_OrderGroup = {
    type: DBDef_OrderGroup.dbKey,
    entityName: DBDef_OrderGroup.entityName,
    module: ModuleFE_OrderGroup,
    route: Route_ActionManager,
    groupId: ['Actions'],
    entityLabel: DBDef_OrderGroup.entityName,
    tags: [],
    mapper: item => [item.name],
    renderer: (item, selected, onClickCallback) => {
        const tags = ModuleFE_Tag.getTagsLabelByTagGroups(item?.tagGroups);
        return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: DBDef_OrderGroup.dbKey, itemLabel: item.name, entityLabel: DBDef_OrderGroup.entityName, hierarchy: 'Actions', selected: selected, onClickCallback: onClickCallback, tags: tags });
    },
    resultRenderer: (id) => {
        const orderGroup = ModuleFE_OrderGroup.cache.unique(id);
        if (!orderGroup)
            throw new MUSTNeverHappenException(`Could not find an FAQ for the given id ${id}`);
        const editable = new EditableDBItemV3(orderGroup, ModuleFE_OrderGroup);
        return _jsx(Editor_OrderGroup, { editable: editable });
    }
};
export const getActionManagerSearchableItems = () => [SearchableItem_Action, SearchableItem_OrderGroup];
//# sourceMappingURL=consts.js.map